const getIsProduction = (
  defaultNodeEnv: string | undefined,
  customNodeEnv: string | undefined
) => {
  if (!defaultNodeEnv || !customNodeEnv) {
    return false
  }

  return defaultNodeEnv === 'production' && customNodeEnv === 'PROD'
}
export const useEnvironment = () => {
  const customNodeEnv = process.env.REACT_APP_NODE_ENVIRONMENT

  // using default environment variable to check for production
  const defaultNodeEnv = process.env.NODE_ENV

  const isProduction = getIsProduction(defaultNodeEnv, customNodeEnv)
  const isUAT = !!customNodeEnv && customNodeEnv === 'UAT'
  const isDevelopment = !!customNodeEnv && customNodeEnv === 'development'

  return { isProduction, isDevelopment, isUAT }
}
